import React from "react";
import { TIME_MAX_LENGTH, TIME_MAX_VALUE, HOUR_FORMAT_WITH_UNITS_REGEX } from "consts";
import { toMinutes } from "utils";
import { formatTimeSpent } from "api";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const TimeSpentAutoSuggest = (props) => {
    const getTime = (q) => {
        const trimmedQuery = (q || "").trim();
        const query = trimmedQuery.substring(0, Math.min(trimmedQuery.length, TIME_MAX_LENGTH));
        const matches = HOUR_FORMAT_WITH_UNITS_REGEX.exec(query);
        if (!matches) {
            return null;
        }

        let onlyHours = Math.min(
            Math.max(parseInt(matches[2] || matches[4], 10) || 0, 0),
            TIME_MAX_VALUE
        );
        let onlyMinutes = Math.min(
            Math.max(parseInt(matches[5] || matches[7], 10) || 0, 0),
            TIME_MAX_VALUE
        );

        return Math.max(toMinutes(onlyHours) + onlyMinutes, 0);
    }

    const onBlur = (e) => {
        if (e.target.value) {
            props.onChange(getTime(e.target.value));
        }
    }

    const suggestTime = (q) => {
        let onlyHours = 0;
        let onlyMinutes = 0;

        const trimmedQuery = (q || "").trim();
        const query = trimmedQuery.substring(0, Math.min(trimmedQuery.length, TIME_MAX_LENGTH));
        const matches = HOUR_FORMAT_WITH_UNITS_REGEX.exec(query);
        if (matches) {
            onlyHours = Math.min(
                Math.max(parseInt(matches[2] || matches[4], 10) || 0, 0),
                TIME_MAX_VALUE
            );
            onlyMinutes = Math.min(
                Math.max(parseInt(matches[5] || matches[7], 10) || 0, 0),
                TIME_MAX_VALUE
            );
        }

        let numbers = [];
        const suggestedValues = props.suggestedValues;
        if (suggestedValues) {
            numbers = suggestedValues.map((num) => toMinutes(num));
        } else {
            numbers = [];
            const hourFrom = Math.max(1, Math.max(onlyHours + 1));
            for (let i = hourFrom; i <= 8; i++) {
                numbers.push(toMinutes(i));
            }
        }

        const inputMinutes = Math.max(toMinutes(onlyHours) + onlyMinutes, 0);
        if (inputMinutes) {
            numbers.push(toMinutes(Math.floor(inputMinutes / 60))); // closest hour
            numbers.push(inputMinutes); // exact input time
            if (!props.hideMinutes) {
                numbers.push(toMinutes(Math.floor(inputMinutes / 60)) + 30); // closest hour + 30 minutes
            }
        }

        numbers.sort((a, b) => a - b);

        return Promise.resolve(
            numbers
                .filter((minutes) => minutes >= inputMinutes)
                .filter((minutes, index, self) => self
                .indexOf(minutes) === index)
        );
    }

    return (
        <AutoSuggest
            label="Time Spent"
            fetchOptions={suggestTime}
            renderOption={(minutes) => ({ value: minutes, label: formatTimeSpent(minutes) })}
            optionIdentifier={(minutes) => minutes}
            onBlur={onBlur}
            {...props}
        />
    );
}

export default TimeSpentAutoSuggest;
